import LinkToDocusaurus from '../LinkToDocusaurus'
import { Paragraph } from '@eggplant/pattern-library'

// TODO: ETD-7990 add docusaurus links
const MoveGitDescription = () =>
  <Paragraph>
    <strong>
      Select a space to move this asset and the assets it included.
      <br />
      During asset moves or duplication, DAI preserves assets relationships by matching asset names.
    </strong>
    <LinkToDocusaurus path=''>Learn more in the DAI documentation</LinkToDocusaurus>
  </Paragraph>

export default MoveGitDescription
